import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import cx from 'classnames';
import styles from './iframe.module.scss';

const IFrameWidgetComponent = ({ className, style, widgetProps }) => {
  const id = _.get(widgetProps, 'uid');
  const url = _.get(widgetProps, 'content');
  const empty = !(url && url.trim().length > 0) || url === 'null';

  var widgetStyle = {
    ...style
  }

  if(empty){
    return false;
  }

  return (
    <div id={id}
      className={cx(className, styles.iframe)}
      style={widgetStyle}
      data-widget-id={id}
    >
      <iframe sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-pointer-lock" 
          src={url} 
      ></iframe>      
    </div>
  )
};

const iframeWidgetEquals = function(prevProps, nextProps){
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'content'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const IFrameWidget = React.memo(IFrameWidgetComponent, iframeWidgetEquals);